import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { iconFor } from "../../lib/categoryIcons";

export default function CategoryGrid({ cats }) {
  return (
    <section className="py-16 md:py-24 bg-white" data-testid="home-categories">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="flex items-end justify-between flex-wrap gap-4">
          <div>
            <div className="text-[11px] tracking-[0.25em] uppercase text-[#0d7a55] font-bold">11 career fields</div>
            <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0F2A1F] leading-tight max-w-2xl">
              Whatever you're great at, someone's hiring for it.
            </h2>
          </div>
          <Link to="/jobs" className="text-[#0F2A1F] font-semibold hover:underline inline-flex items-center gap-1.5" data-testid="see-all-jobs">
            See all jobs <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>
        <div className="mt-10 grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
          {cats.map((c, i) => {
            const Icon = iconFor(c.key);
            return (
              <Link key={c.key} to={`/jobs?category=${c.key}`} className="group relative rounded-2xl bg-[#FAF7EE] p-4 sm:p-6 ring-1 ring-[#0F2A1F]/10 hover:bg-[#0F2A1F] hover:ring-[#0F2A1F] transition-colors duration-300 fade-up" style={{ animationDelay: `${i * 40}ms` }} data-testid={`category-${c.key}`}>
                <div className="flex items-start justify-between">
                  <div className="h-10 w-10 sm:h-12 sm:w-12 rounded-xl bg-[#0F2A1F] group-hover:bg-[#D4AF37] flex items-center justify-center transition-colors">
                    <Icon className="h-5 w-5 text-[#D4AF37] group-hover:text-[#0F2A1F] transition-colors" />
                  </div>
                  <ArrowUpRight className="h-5 w-5 text-[#0F2A1F]/30 group-hover:text-[#D4AF37] transition-colors" />
                </div>
                <h3 className="mt-4 sm:mt-6 text-lg sm:text-2xl font-bold text-[#0F2A1F] group-hover:text-white leading-tight transition-colors">{c.label}</h3>
                <p className="mt-1.5 hidden sm:block text-sm text-[#0F2A1F]/60 group-hover:text-white/70 leading-relaxed line-clamp-2 transition-colors">{c.blurb}</p>
                <div className="mt-3 text-xs sm:text-sm font-bold text-[#0d7a55] group-hover:text-[#D4AF37] transition-colors">{c.count} open {c.count === 1 ? "role" : "roles"}</div>
              </Link>
            );
          })}
          <Link to="/jobs" className="rounded-2xl bg-[#D4AF37] p-4 sm:p-6 flex flex-col justify-between hover:bg-[#e2bf48] transition-colors" data-testid="category-all">
            <div className="text-lg sm:text-2xl font-bold text-[#0F2A1F] font-serif leading-tight">Not sure yet?</div>
            <div className="mt-4 text-sm font-bold text-[#0F2A1F] inline-flex items-center gap-1">Browse everything <ArrowUpRight className="h-4 w-4" /></div>
          </Link>
        </div>
      </div>
    </section>
  );
}
